export default __webpack_public_path__ + "static/media/ic_oxxo.57c2e75c.svg";